module.exports = __webpack_public_path__ + "static/media/coming-up.084a3547.svg";